import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'controls'
import { Row, Col } from 'flexbox'

class ConfirmAction extends Component {
  static propTypes = {
    message: PropTypes.any.isRequired,
    children: PropTypes.any.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    disabledConfirm: PropTypes.bool
  }

  static defaultProps = {
    message: '',
    loading: false
  }

  render() {
    const {
      message,
      children,
      onConfirm,
      onCancel,
      loading,
      confirmButtonLabel = "Aceptar",
      cancelButtonLabel = "Cancelar",
      disabledConfirm,
      ...modalProps
    } = this.props

    return (
      <Modal {...modalProps} onClose={onCancel}>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <header>{message}</header>
          {children}
          <br />
          <Row>
            <Col xs={6} sm={4} smOffset={1}>
              <Button color="primary" fullWidth outline onClick={onCancel}>
                {cancelButtonLabel}
              </Button>
            </Col>
            <Col xs={6} sm={4} smOffset={2}>
              <Button
                color="primary"
                fullWidth
                onClick={onConfirm}
                loading={loading}
                disabled={disabledConfirm}
              >
                {confirmButtonLabel}
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    )
  }
}

export default ConfirmAction
